/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from 'react';
import Message from '../form/Message';

const PracticesList = props => {
    const practices = props.practices;
    let selectedId = -1;
    if (props.selected) {
        selectedId = props.selected.id;
    }

    // Check for more than one primary practice
    let primaryCount = 0;
    practices.forEach(practice => {
        if (practice.primary_practice) {
            primaryCount++;
        }
    });

    let primaryMessage = null;
    if (primaryCount < 1 && practices.length > 0) {
        primaryMessage =
            'Please designate one of your practices as the primary practice.';
    } else if (primaryCount > 1) {
        primaryMessage =
            'You have designated multiple primary practices. Please choose only one.';
    }

    return (
        <div className="ManagePage__list">
            {practices.map(practice => {
                let className = 'ManagePage__item';
                if (practice.id === selectedId) {
                    className = 'ManagePage__item-selected';
                }

                let icon = null;
                if (practice.primary_practice) {
                    icon = <i className="fa fa-hospital-o"></i>;
                }

                return (
                    <a
                        className={className}
                        key={practice.id}
                        onClick={() => {
                            props.onSelection(practice);
                        }}>
                        {icon} {practice.name}
                    </a>
                );
            })}

            <Message error={primaryMessage} />
        </div>
    );
};

export default PracticesList;
